import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { useTranslation } from 'react-i18next'

import {
  HandleYearFilterSelectionType,
  YearFilterValue,
} from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth/Types'

interface propsTypes {
  yearFilterValue: YearFilterValue
  YearOfBirthFilterOptions?: string[]
  handleYearFilterSelection: HandleYearFilterSelectionType
}

const YOBFilterCategorySelection = (props: propsTypes) => {
  const { t } = useTranslation()
  const {
    yearFilterValue,
    handleYearFilterSelection,
    YearOfBirthFilterOptions,
  } = props

  return (
    <Grid item xs={12}>
      <FormControl variant="standard" sx={{ width: '100%' }}>
        <InputLabel id="yob-filter-category-selection">
          {t('filters.yob.dialogContent.categoryLabel')}
        </InputLabel>
        <Select
          value={yearFilterValue.label}
          onChange={(e: any) => handleYearFilterSelection(e)}
          label={t('filters.yob.dialogContent.categoryLabel')}
          sx={{ width: '100%' }}
        >
          {YearOfBirthFilterOptions &&
            YearOfBirthFilterOptions.map((type: string, index: number) => {
              return (
                <MenuItem
                  key={type.toLowerCase().replace(' ', '_') + index}
                  value={type.toLowerCase().replace(' ', '_')}
                >
                  {t(
                    `filters.yob.categoryOptions.${type
                      .toLocaleLowerCase()
                      .replace(' ', '_')}`,
                  )}
                </MenuItem>
              )
            })}
        </Select>
      </FormControl>
    </Grid>
  )
}
export default YOBFilterCategorySelection
